// extracted by mini-css-extract-plugin
export var contact = "StoreInfoCard-module--contact--9c613";
export var contactHours = "StoreInfoCard-module--contactHours--0d5bb";
export var contactHoursItem = "StoreInfoCard-module--contactHoursItem--6de1e";
export var contactMap = "StoreInfoCard-module--contactMap--640bc";
export var contactMapIcon = "StoreInfoCard-module--contactMapIcon--d3e4d";
export var contactMapLink = "StoreInfoCard-module--contactMapLink--7b3b7";
export var contactNote = "StoreInfoCard-module--contactNote--676ad";
export var contactPhones = "StoreInfoCard-module--contactPhones--6e7a9";
export var contactTitle = "StoreInfoCard-module--contactTitle--efda8";
export var daysListRow = "StoreInfoCard-module--daysListRow--c7937";
export var heading = "StoreInfoCard-module--heading--f18e2";
export var secondary = "StoreInfoCard-module--secondary--19890";
export var weekDays = "StoreInfoCard-module--weekDays--94a7b";